import { useEffect, useState } from "react";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";
import { ROLES } from "@/constants/testIds";

// Fix AW (2026-10-27): crear o editar un rol personalizado (nombre + secciones).
export default function RoleDialog({ open, onOpenChange, role, areas, onSubmit }) {
  const [name, setName] = useState("");
  const [selected, setSelected] = useState([]);
  const [saving, setSaving] = useState(false);
  const isEdit = Boolean(role);

  useEffect(() => {
    setName(role?.name || "");
    setSelected(role?.areas || []);
  }, [role, open]);

  const toggle = (key, on) => setSelected((cur) => (on ? [...cur.filter((k) => k !== key), key] : cur.filter((k) => k !== key)));

  const handleSave = async () => {
    setSaving(true);
    try {
      await onSubmit({ name: name.trim(), areas: selected }, role);
    } finally {
      setSaving(false);
    }
  };

  const invalid = name.trim().length < 2 || selected.length === 0;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md max-h-[90vh] overflow-y-auto" data-testid={ROLES.dialog}>
        <DialogHeader>
          <DialogTitle className="font-serif text-2xl">{isEdit ? "Editar rol" : "Nuevo rol"}</DialogTitle>
          <DialogDescription>La persona con este rol solo verá las secciones que marques.</DialogDescription>
        </DialogHeader>

        <div className="space-y-4 py-2">
          <div>
            <Label className="text-sm text-muted-foreground mb-1 block">Nombre del rol</Label>
            <Input value={name} onChange={(e) => setName(e.target.value)} maxLength={40} placeholder="Ej: Contabilidad y ventas" data-testid={ROLES.nameInput} />
          </div>

          <div>
            <Label className="text-sm text-muted-foreground mb-2 block">Secciones que puede ver</Label>
            <div className="space-y-3">
              {areas.map((a) => (
                <label key={a.key} className="flex items-start gap-3 cursor-pointer">
                  <Checkbox
                    className="mt-0.5"
                    checked={selected.includes(a.key)}
                    onCheckedChange={(v) => toggle(a.key, v === true)}
                    data-testid={`${ROLES.areaPrefix}${a.key}`}
                  />
                  <span>
                    <span className="block text-sm font-medium text-foreground">{a.label}</span>
                    <span className="block text-xs text-muted-foreground">{a.description}</span>
                  </span>
                </label>
              ))}
            </div>
            {selected.length === 0 && (
              <p className="text-xs text-destructive mt-2">Marca al menos una sección.</p>
            )}
          </div>
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} data-testid={ROLES.cancelButton}>Cancelar</Button>
          <Button onClick={handleSave} disabled={saving || invalid} data-testid={ROLES.saveButton}>
            {saving ? "Guardando..." : "Guardar"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
